import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import {TableContainer, ITableContainerProps} from 'components/table/table-container';
import {EEntityType} from 'shared/constants/entities';

import './document-types-codes.less';

export const DocumentTypeCodes = ({entityName, url}: ITableContainerProps) => {
    const history = useHistory();
    const entityUrl = `${url}/${entityName}`;

    useEffect(() => {
        history.replace(entityUrl);
    }, [entityName, history]);

    return (
        <div className="document-type-codes">
            <TableContainer
                entityName={entityName}
                entityType={EEntityType.TABLE}
                hideTitle
                url={entityUrl}
            />
        </div>
    );
};
